<template>
  <div>
    <view-reports-modal
      v-if="currentFoundationalReport"
      :data="currentFoundationalReport"
      @close-modal="handleCloseModal"
    />
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import ViewReportsModal from '../../components/modals/ViewReportsModal.vue';
import { SEGMENT_EVENTS } from '../../constants';

export default {
  components: {
    ViewReportsModal,
  },
  computed: {
    ...mapGetters(['currentFoundationalReport', 'reports']),
  },
  watch: {
    currentFoundationalReport() {
      this.foundationalReport = this.currentFoundationalReport;
    },
    reports() {
      if (!this.currentFoundationalReport) {
        this.handleGetCurrentReportFromId();
      }
    },
  },
  data: () => ({
    foundationalReport: null,
  }),
  mounted() {
    if (this.currentFoundationalReport) {
      this.foundationalReport = this.currentFoundationalReport;
    } else {
      this.handleGetCurrentReportFromId();
    }
  },
  methods: {
    ...mapActions(['setCurrentFoundationalReport']),
    handleGetCurrentReportFromId() {
      if (this.reports && this.reports.length) {
        const id = this.$route.params.id;
        const currentFoundationalReport = this.reports.find(
          report => Number(report.id) === Number(id)
        );
        if (currentFoundationalReport) {
          this.setCurrentFoundationalReport(
            JSON.parse(JSON.stringify(currentFoundationalReport))
          );
          return;
        }
        this.$router.push({ name: 'Home', query: { report: -1 } })
      }
    },
    handleCloseModal() {
      window.analytics.track(SEGMENT_EVENTS.CLOSED_FOUNDATIONAL_REPORT_MODAL, {
        contentTitle: this.currentFoundationalReport.title,
        contentId: this.currentFoundationalReport.id,
        contentType: 'Foundational Reports',
      });
      this.setCurrentFoundationalReport(null);
      this.$router.push({ name: 'Home' });
    },
  },
};
</script>
